import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, ProtectedRoute, AuthCallback } from './components/Auth';
import { ThemeProvider } from './theme/ThemeProvider';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import MobileAuthBridge from './pages/MobileAuthBridge';
import './App.css';

function AppRouter() {
  const hash = window.location.hash;

  // Native app OAuth bridge: hand the session back to the Android deep link.
  // Must be checked before the web session_id callback so it isn't hijacked.
  if (window.location.pathname === '/mobile-auth') {
    return <MobileAuthBridge />;
  }

  if (hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <div className="App min-h-screen bg-main text-text-main">
        <BrowserRouter>
          <AuthProvider>
            <Toaster position="top-right" theme="dark" />
            <AppRouter />
          </AuthProvider>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
